import { CloseIcon } from '../../assets/icon/svg';

interface Props {
    handleClose: () => void;
    isLoading?: boolean;
}

export default function CloseButtonModal({ isLoading = false, handleClose }: Props) {
    return (
        <button
            disabled={isLoading}
            className="disabled:cursor-not-allowed text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-full w-8 h-8 flex items-center justify-center"
            onClick={handleClose}
        >
            <CloseIcon />
        </button>
    );
}